export default [
    {
        src: require("../assets/redesign2020/logo-garden/carvana.png"),
        alt: "Carvana"
    },
    {
        src: require("../assets/redesign2020/logo-garden/peloton.png"),
        alt: "Peloton"
    },
    {
        src: require("../assets/redesign2020/logo-garden/mattel.png"),
        alt: "Mattel"
    },
    {
        src: require("../assets/redesign2020/logo-garden/dcu.png"),
        alt: "DCU"
    },
    {
        src: require("../assets/redesign2020/logo-garden/fareway.png"),
        alt: "Fareway"
    },
    {
        src: require("../assets/redesign2020/logo-garden/yelp.png"),
        alt: "Yelp"
    },
    {
        src: require("../assets/redesign2020/logo-garden/prh.png"),
        alt: "Penguin Random House"
    }
];